import { z } from 'zod';
import { metadata } from './helpers';
import { contentBase } from './content';

export const reasonToChooseUsContentSchema = z.object({
  metadata: metadata,
  data: z.array(
    z.object({
      title: z.string(),
      position: z.number(),
      highlighted: z.boolean(),
      reasons: z.array(
        z.object({
          label: z.string(),
        })
      ),
    })
  ),
});

export const contentTypeReasonsToChooseUsContentSchema = contentBase.extend({
  content: reasonToChooseUsContentSchema,
});

export type ContentTypeReasonsToChooseUsContentInput = z.infer<
  typeof contentTypeReasonsToChooseUsContentSchema
>;
